import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { register } from './serviceWorkerRegistration';
import './index.css';
import { SettingsProvider } from './useSetting';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
	<React.StrictMode>
		<SettingsProvider>
			<App />
		</SettingsProvider>
	</React.StrictMode>,
);

register();
